<script>
import { mapActions } from "vuex";
import { required, maxLength } from "@vuelidate/validators";
import { CREATE_SUPPORT_DATA_ACCESS } from "@/store/actions.type";
import { email } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
  name: "DataAccessRequest",
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      dataAccess: {
        description: null,
      },
      isAccessUploading: false,
      fileSizeError: false,
    };
  },
  validations() {
    return {
      dataAccess: {
        description: {
          required,
          maxLength: maxLength(500),
        },
        email: { email },
      },
    };
  },
  methods: {
    ...mapActions({
      createSupportDataAccess: CREATE_SUPPORT_DATA_ACCESS,
    }),
    goToLeaveFeedback() {
      this.$router.push("/feedback");
    },
    async submit() {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        try {
          this.isAccessUploading = true;
          await this.createSupportDataAccess(this.dataAccess);
          // clear out all values in the suggestion
          Object.keys(this.dataAccess).forEach(
            (key) => (this.dataAccess[key] = null)
          );
          this.v$.$reset();
          this.isAccessUploading = false;
          // Remove file from uploader
          this.$refs.modal.show();
        } catch (error) {
          this.isAccessUploading = false;
          throw new Error(error);
        }
      }
    },
  },
};
</script>

<template>
  <cv-modal id="add-data-access" ref="modal">
    <template #title>Request sent</template>
    <template #content>
      <p>Thank you for your time, we will now proccess your request!</p>
    </template>
    <template #primary-button>Close</template>
  </cv-modal>

  <cv-grid class="main">
    <div class="detail-tile-container">
      <div class="detail-description-container">
        <p class="detail-title"><strong> Data Access Request</strong></p>
        <p class="detail-description">
          Thank you for submitting your data access request. Please provide the
          following details:
        </p>
        <br />
        <ul>
          <li class="detail-bullet">
            Who approved your data access (provide an email)
          </li>
          <li class="detail-bullet">What specific access do you need</li>
          <li class="detail-bullet">
            Any additional comments or relevant information
          </li>
        </ul>
      </div>
      <div class="detail-input-container">
        <cv-interactive-tooltip direction="bottom">
          <template #label>Approver Email</template>
          <template #content>
            <p>Provide the email of who approved this request.</p>
          </template>
        </cv-interactive-tooltip>
        <cv-text-area
          v-model="dataAccess.email"
          placeholder="e.g. John_M_Griffin@uk.ibm.com"
        >
          <template v-if="v$.dataAccess.email.$invalid" #invalid-message>
            Must be a valid email address.
          </template>
        </cv-text-area>
        <br />
      </div>
      <div class="detail-input-container">
        <cv-interactive-tooltip direction="bottom">
          <template #label>Access Details</template>
          <template #content>
            <p>Let us know details about your request.</p>
          </template>
        </cv-interactive-tooltip>
        <cv-text-area
          v-model="dataAccess.description"
          placeholder="e.g. I need Super Admin access."
        >
          <template
            v-if="
              !v$.dataAccess.description.maxLength &&
              v$.dataAccess.description.$error
            "
            #invalid-message
          >
            Message can't exceed 500 characters
          </template>
        </cv-text-area>
        <br />
        <span>
          Characters Remaining:
          {{
            dataAccess.description ? 500 - dataAccess.description.length : 500
          }}
        </span>
      </div>
    </div>
    <cv-button-set class="button-set">
      <cv-button kind="secondary" @click="goToLeaveFeedback"> Back </cv-button>
      <cv-button kind="primary" @click="submit"> Submit </cv-button>
    </cv-button-set>
  </cv-grid>
</template>

<style lang="scss" scoped>
.submit-button-container {
  display: flex;
  width: 100%;
}
.main {
  margin-left: 44px;
}
.rating-container {
  padding-top: 0.5rem;
}
.error-message {
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.34;
  letter-spacing: 0.32px;
  margin: 0.25rem 0 0;
  overflow: hidden;
  color: var(--cds-danger-02);
}
span {
  float: right;
  font-size: 0.75rem;
  font-weight: 400;
  line-height: 1.34;
  letter-spacing: 0.32px;
  display: inline-flex;
  align-items: center;
  color: var(--cds-text-02);
}
.detail-bullet {
  color: #ffffff;
  font-size: 16px;
  margin-bottom: 10px;
}

.button-set {
  max-width: 1103px;
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
  margin-left: auto;
  margin-right: 15px;
  padding: 0 1rem;
}

@media (max-width: 47.75rem) {
  .button-set {
    display: block;
    margin: 0 auto;
    padding: 0 1rem;
  }

  .button-set > * {
    width: 33%;
    max-width: none;
  }
}
</style>
